// config.js
const config = {
  // API_URL: "http://192.168.0.170:8080", // Local Host Server
  API_URL:
    "https://dotdashacademybackend-eshbf7faadckgwht.eastasia-01.azurewebsites.net", // Azure Host Server
};

export default config;
